import React from 'react'
import classNames from 'classnames'
import { isDetachedMode } from 'helpers/URLHelper'

import { getSavedPanelWidth } from 'components/Layout/AppLayout/Panel/resizable'
import { Global } from 'components/Layout/AppLayout'
import * as Icons from 'components/Utils/Icons'
import { TOP_BAR_HEIGHT } from 'screens/Topbar/TopBarRight'
import { TopBarRightLoading } from 'screens/Topbar/TopBarRightLoading'
import { COLORMODES } from '../../data/userPreferences/selectors'
import { LS_COLOR_MODE_KEY } from '../ColorModeSync'
import { LoadingLine } from './LoadingLine'

export const SidebarListLoading = ({ className }) => (
  <div className={`padding-top-larger ${className}`}>
    <LoadingLine iconClass={Icons.PieIcon} lineWidth="50%" marginBottom={30} />
    <LoadingLine
      iconClass={Icons.CircleEmptyIcon}
      lineWidth="20%"
      marginBottom={30}
    />
    <LoadingLine
      iconClass={Icons.CircleIcon}
      lineWidth="40%"
      marginBottom={30}
    />
    <LoadingLine iconClass={Icons.SquareIcon} lineWidth="30%" />
  </div>
)

export const SidebarHeaderLoading = () => (
  <div className="padding-horizontal-large padding-vertical-large">
    <LoadingLine
      animationDelay={1}
      iconClass={Icons.CircleEmptyIcon}
      lineWidth="30%"
      iconSize={20}
      marginTop={5}
    />
  </div>
)

export const BodySidebarLoading = () => (
  <div className="padding-large">
    <LoadingLine
      iconClass={Icons.SquareEmptyIcon}
      lineWidth="40%"
      marginBottom={20}
    />
    <LoadingLine
      iconClass={Icons.CircleEmptyIcon}
      lineWidth="60%"
      marginBottom={20}
    />
    <LoadingLine
      iconClass={Icons.CircleIcon}
      lineWidth="50%"
      marginBottom={20}
    />
    <LoadingLine
      iconClass={Icons.SquareIcon}
      lineWidth="90%"
      marginBottom={20}
    />
    <LoadingLine
      iconClass={Icons.TriangleIcon}
      lineWidth="20%"
      marginBottom={20}
    />
    <LoadingLine
      iconClass={Icons.CircleIcon}
      lineWidth="30%"
      marginBottom={20}
    />
  </div>
)

export const SidebarLoading = () => (
  <div
    className={classNames(
      'dark-mode sidepanel height-full background-shade-100',
      {
        'color-mode-elevated border-shade-100':
          localStorage.getItem(LS_COLOR_MODE_KEY) !== COLORMODES.DARK,
      },
      'flexbox flexbox-grow flexbox-column overflow-hidden border-right-medium border-shade-50'
    )}
    style={{ width: getSavedPanelWidth() }}
  >
    <div
      className="flexbox flexbox-align-center padding-horizontal-normal width-full"
      style={{ height: TOP_BAR_HEIGHT }}
    >
      <LoadingLine lineWidth="50%" marginBottom={0} />
    </div>
    <div className="padding-bottom-medium padding-horizontal-normal">
      <div
        className="margin-bottom-large border-small radius-normal font-size-normal font-weight-bold padding-horizontal-large no-outline padding-vertical-normal shade-100 background-primary border-primary width-full font-size-large flexbox-justify-start"
        style={{ opacity: '.4' }}
      >
        <LoadingLine lineWidth="30%" marginBottom={0} />
      </div>
      <LoadingLine lineWidth="60%" marginBottom={0} />
    </div>
    <BodySidebarLoading />
  </div>
)

export const EditorLoading = () => (
  <div
    style={{ marginTop: 46 }}
    className="note-header width-full padding-bottom-larger"
  >
    <LoadingLine size={26} lineWidth="80%" marginBottom={15} />
    <LoadingLine size={26} lineWidth="60%" marginBottom={30} />
    <LoadingLine lineWidth="95%" marginBottom={10} />
    <LoadingLine lineWidth="100%" marginBottom={10} />
    <LoadingLine lineWidth="85%" marginBottom={10} />
    <LoadingLine lineWidth="60%" marginBottom={10} />
  </div>
)

export const NotePanelLoading = () => (
  <div className="l-main-body slite-design-system flexbox flexbox-grow">
    <div className="l-note-grid note-panel flexbox-grow">
      <div className="scrollable scroll-y l-note-content width-full height-full background-shade-100">
        <div className="note-panel-center">
          <EditorLoading />
        </div>
      </div>
    </div>
  </div>
)

const AppLoading = React.memo(function() {
  if (isDetachedMode()) {
    return <NotePanelLoading />
  }
  return (
    <Global>
      <div className="l-app-grid grid height-full">
        <div
          className="l-sidebar-body"
          style={{ gridTemplateColumns: getSavedPanelWidth() }}
        >
          <SidebarLoading />
        </div>
        <TopBarRightLoading />
        <NotePanelLoading />
      </div>
    </Global>
  )
})

export default AppLoading
